// How the matrix is built: the tiers, their templates and their priors (plan §3.2).
//
// This file is deliberately data-shaped: the wizard shows it to the owner as "как се строи
// матрицата", and changing a prior or a cap is an edit here, not a redesign.
export const TIERS = [
    'core',
    'core_area',
    'service',
    'service_area',
    'intent',
    'en',
];
/** Expected new leads per 60 results, as a 0–100 prior, before any run has been observed. */
export const TIER_PRIORS = {
    core: 60,
    core_area: 35,
    service: 30,
    service_area: 15,
    intent: 20,
    en: 25,
};
/** Days between runs per tier. The selector doubles these on zero-streaks (plan §3.6). */
export const DEFAULT_TIER_COOLDOWNS = {
    core: 14,
    core_area: 21,
    service: 21,
    service_area: 30,
    intent: 45,
    en: 45,
};
/** core_area uses only the first N synonyms: every synonym × every area is mostly repeats. */
export const CORE_AREA_SYNONYMS = 2;
/** service_area uses only the first N services, and only big areas. */
export const SERVICE_AREA_SERVICES = 3;
/** city_areas.search_weight at or above which an area also gets service queries. */
export const BIG_AREA_WEIGHT = 2;
/** A big area's queries are expected to yield a little more. */
export const BIG_AREA_YIELD_FACTOR = 1.2;
/** English phrasings for tourist niches; {name} is verticals.name_en, {city} the Latin city. */
export const EN_TEMPLATES = [
    '{name} {city}',
    '{name} in {city}',
    'best {name} {city}',
];
/** Google text search pages per query (places.ts paginates to 3 × 20). */
export const PAGES_PER_QUERY = 3;
//# sourceMappingURL=templates.js.map